import { put, takeLatest } from 'redux-saga/effects'
import {
    GET_EXPIREDPASSWORD_USERINFO,
    GET_EXPIREDPASSWORD_USERINFO_SUCCESSED,
    GET_EXPIREDPASSWORD_USERINFO_FAILED,
    UPDATE_EXPIREDPASSWORD_USERINFO,
    UPDATE_EXPIREDPASSWORD_USERINFO_SUCCESSED,
    SAVE_EXPIREDPASSWORD,
    SAVE_EXPIREDPASSWORD_FAILED,
    SAVE_EXPIREDPASSWORD_SUCCESSED
} from '../actions/actionTypes'
import { ApiService } from '../services/ApiService'
import { AuthApiService } from '../services/AuthApiService'


const _apiService = new ApiService()

const _authApiService = new AuthApiService

function* fetchExpiredPasswordUserInfo(action) {
  try {
    let response = yield _apiService.getUserInformation(action.params.refnum)
    if (!response || response.error) {
      if (response && response.errorData && response.errorData.response && response.errorData.response.data && response.errorData.response.data.message) {
        var responseErrMsg = response.errorData.response.data.message
        var description = response.errorData.response.data.description
    
        yield put({
          type: GET_EXPIREDPASSWORD_USERINFO_FAILED,
          message: responseErrMsg,
          infoError: responseErrMsg,
          data: Object.assign({
          }, { message: responseErrMsg, description: description })
        })
      } else {
        yield put({

          type: GET_EXPIREDPASSWORD_USERINFO_FAILED,
          message: response.error || 'An error has occurred'
        })
      }
    } else {
      yield put({
        type: GET_EXPIREDPASSWORD_USERINFO_SUCCESSED,
        data: Object.assign({
        }, response, { 
        currentpassword:null,
        password:null,
        confirmpassword:null,
        refnum:action.params.refnum})
      })
    }
  } catch (error) {
    yield put({
      type: GET_EXPIREDPASSWORD_USERINFO_FAILED,
      message: error.message
    })
  }
}

export function* watchFetchExpiredPasswordUserInfo() {
  yield takeLatest(GET_EXPIREDPASSWORD_USERINFO, fetchExpiredPasswordUserInfo)
}

function* updateExpiredPasswordUserInfo(action) {
        yield put({
          type: UPDATE_EXPIREDPASSWORD_USERINFO_SUCCESSED,
          data: Object.assign({
          }, {} , action.params)
        })
}
  
export function* watchExpiredPasswordUpdateUserInfo() {
    yield takeLatest(UPDATE_EXPIREDPASSWORD_USERINFO, updateExpiredPasswordUserInfo)
}

function* saveExpiredPassword(action) {
  try {
    let payload = {
      currentPassword:action.params.currentpassword,
      newPassword:action.params.password,
      confirmPassword: action.params.confirmpassword
    }
    let response = yield _apiService.updatePassword(action.params.userLogin,payload)
    
    if (!response || response.error) {
        if (response && response.errorData && response.errorData.response && response.errorData.response.data && response.errorData.response.data.message) {
          var responseErrMsg = response.errorData.response.data.message
          var description = response.errorData.response.data.description
          yield put({
            type: SAVE_EXPIREDPASSWORD_FAILED,
            message: responseErrMsg,
            infoError: responseErrMsg,
            data: Object.assign({
            }, { message: responseErrMsg, description: description })
          })
        } else {
          yield put({
            type: SAVE_EXPIREDPASSWORD_FAILED,
            message: response.error || 'An error has occurred'
          })
        }
      } else {
      yield put({
        type: SAVE_EXPIREDPASSWORD_SUCCESSED,
        data: Object.assign({
        }, action.params,response)
      })
    }
  } catch (error) {
    yield put({
      type: SAVE_EXPIREDPASSWORD_FAILED,
      message: error.message
    })
  }
}

export function* watchSaveExpiredPassword() {
  yield takeLatest(SAVE_EXPIREDPASSWORD, saveExpiredPassword)
}